<template>
  <WsCreate
    :modelName="modelName"
    :label="label"
    :fields="fields"
    :primary="pageSetting.primary"
    :secondary="pageSetting.secondary"
    parentModelName="contractor_license_template"
    :parentId="$route.params.id"
    :customParentData="customParentData"
  >
  </WsCreate>
</template>

<script>
import model from "@/models/contractor_license_template";
export default {
  data: () => ({
    modelName: "contractor_license_template_ver",
    label: "承攬商資格證公版版本",
    fields: model.fields.last_version.fields,
    customParentData: (modelData, parentModelData) => {
      if (modelData.area) {
        return {
          area: modelData.area.id,
        };
      } else if (parentModelData) {
        if (parentModelData.area) {
          return { area: parentModelData.area.id };
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    pageSetting: {
      primary: [
        {
          type: "infoCard",
          floors: [
            {
              title: "版本內容",
              fields: [
                "statitory_extension_period",
                "recommend_notify_period",
                "locales",
                "acts",
              ],
            },
          ],
        },
      ],
      secondary: [],
    },
  }),
};
</script>